/* eslint-disable */
//import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/loanOfficers/LoanOfficerLanding';

class LoanOfficerLanding {
    constructor() {
        this.container = document.querySelector('#LoanOfficerLanding');

        if (this.container) {
            ReactDOM.render(<App />, document.getElementById('LoanOfficerLanding'));
        }
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {

    }
}

export default LoanOfficerLanding;